// CSR-1472 — human-readable labels for the insured profile fields tracked in
// change history (`TRACKED_INSURED_FIELDS`). Shared by the Activity Timeline
// (Insured edit events) and the Insured Detail "Change History" card so both
// surfaces name fields identically.
export const INSURED_FIELD_LABELS: Record<string, string> = {
  name: "Company Name",
  commercialName: "DBA / Commercial Name",
  dbaName: "DBA",
  dotNumber: "DOT Number",
  mcNumber: "MC Number",
  email: "Email",
  telephone: "Phone",
  fax: "Fax",
  phyStreet: "Physical Street",
  phyCity: "Physical City",
  phyState: "Physical State",
  phyZip: "Physical ZIP",
  phyCountry: "Physical Country",
  mailingStreet: "Mailing Street",
  mailingCity: "Mailing City",
  mailingState: "Mailing State",
  mailingZip: "Mailing ZIP",
  mailingCountry: "Mailing Country",
  businessOrg: "Business Type",
  companyOfficer: "Company Officer",
  totalDrivers: "Total Drivers",
  totalPowerUnits: "Total Power Units",
  totalFleetSize: "Total Fleet Size",
  salesAgent: "Sales Agent",
  retentionAgent: "Retention Agent",
};

export function insuredFieldLabel(field: string): string {
  return INSURED_FIELD_LABELS[field] ?? field;
}
